import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAppletvComponent } from './simple-icons-appletv.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAppletvComponent ],
    exports:      [ SimpleIconsAppletvComponent ],
    bootstrap:    []
})
export class SimpleIconsAppletvModule {}
